import axiosClient from "./axiosClient";

const chatService = {
  getUsers: () => axiosClient.get("/chat/users"),
  getMessages: (u1, u2) =>
    axiosClient.get("/chat/messages", { params: { u1, u2 } }),
  markSeen: (ids, user_id) =>
    axiosClient.post("/chat/messages/seen", ids, { params: { user_id } }),
  getOnlineUsers: () => axiosClient.get("/chat/online-users"),
  connectSocket: (userId) => new WebSocket(`ws://localhost:8000/api/chat/ws/${userId}`),
};

export default chatService;
